type SkeletonProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export function Skeleton({ className = "", width, height }: SkeletonProps) {
  const style: Record<string, string | number> = {};
  if (width) style.width = typeof width === "number" ? `${width}px` : width;
  if (height) style.height = typeof height === "number" ? `${height}px` : height;

  return (
    <div
      className={`festapp-skeleton ${className}`}
      style={style}
    />
  );
}

// ============================================
// Artist Skeletons
// ============================================

export function ArtistCardSkeleton() {
  return (
    <div className="festapp-artist-card festapp-artist-card-skeleton">
      <div className="festapp-artist-card-image">
        <Skeleton className="festapp-skeleton-fill" />
      </div>
      <div className="festapp-artist-card-content">
        <Skeleton height={20} width="75%" />
        <Skeleton height={14} width="50%" />
      </div>
    </div>
  );
}

export function ArtistDetailSkeleton() {
  return (
    <div className="festapp-artist-detail festapp-artist-detail-skeleton">
      <div className="festapp-artist-hero">
        <Skeleton height={40} width="50%" />
        <Skeleton height={20} width="30%" />
        <div className="festapp-artist-hero-media">
          <div className="festapp-artist-hero-left">
            <div className="festapp-artist-hero-image-container">
              <Skeleton className="festapp-skeleton-fill" />
            </div>
          </div>
          <div className="festapp-artist-hero-right">
            <Skeleton className="festapp-artist-media-skeleton" />
          </div>
        </div>
      </div>
      <section className="festapp-artist-section">
        <Skeleton height={24} width={100} />
        <div className="festapp-artist-schedules">
          <div className="festapp-artist-schedule-item festapp-artist-schedule-item-skeleton">
            <Skeleton width={100} height={40} />
            <Skeleton width="60%" height={20} />
          </div>
          <div className="festapp-artist-schedule-item festapp-artist-schedule-item-skeleton">
            <Skeleton width={100} height={40} />
            <Skeleton width="50%" height={20} />
          </div>
        </div>
      </section>
      <section className="festapp-artist-section">
        <Skeleton height={20} width="100%" />
        <Skeleton height={20} width="95%" />
        <Skeleton height={20} width="70%" />
      </section>
    </div>
  );
}

// ============================================
// Schedule Skeletons
// ============================================

export function ScheduleItemSkeleton() {
  return (
    <div className="festapp-schedule-item festapp-schedule-item-skeleton">
      <div className="festapp-schedule-item-time">
        <Skeleton width={50} height={18} />
        <Skeleton width={40} height={14} />
      </div>
      <div className="festapp-schedule-item-content">
        <Skeleton height={22} width="70%" />
        <Skeleton height={16} width="40%" />
      </div>
      <Skeleton width={20} height={20} className="festapp-skeleton-circle" />
    </div>
  );
}

// ============================================
// Event Skeletons
// ============================================

export function EventDetailSkeleton() {
  return (
    <div className="festapp-event-detail festapp-event-detail-skeleton">
      <div className="festapp-event-hero">
        <div className="festapp-event-hero-image-container">
          <Skeleton className="festapp-skeleton-fill" />
        </div>
        <Skeleton height={40} width="70%" />
        <Skeleton height={20} width="40%" />
      </div>
      <section className="festapp-event-section">
        <Skeleton height={24} width={100} />
        <div className="festapp-event-schedules">
          <div className="festapp-event-schedule-item festapp-event-schedule-item-skeleton">
            <Skeleton width={120} height={40} />
            <Skeleton width="40%" height={20} />
          </div>
        </div>
      </section>
      <section className="festapp-event-section">
        <Skeleton height={24} width={120} />
        <div className="festapp-event-performers-skeleton">
          <Skeleton className="festapp-event-performer-chip-skeleton" />
          <Skeleton className="festapp-event-performer-chip-skeleton" />
          <Skeleton className="festapp-event-performer-chip-skeleton" />
        </div>
      </section>
      <section className="festapp-event-section">
        <Skeleton height={20} width="100%" />
        <Skeleton height={20} width="90%" />
        <Skeleton height={20} width="60%" />
      </section>
    </div>
  );
}

// ============================================
// UI Control Skeletons
// ============================================

export function DaySelectorSkeleton() {
  return (
    <div className="festapp-day-selector festapp-day-selector-skeleton">
      <Skeleton className="festapp-day-btn-skeleton" />
      <Skeleton className="festapp-day-btn-skeleton" />
      <Skeleton className="festapp-day-btn-skeleton" />
    </div>
  );
}

export function FilterDropdownSkeleton() {
  return (
    <Skeleton className="festapp-filter-dropdown-skeleton" />
  );
}

export function SearchInputSkeleton() {
  return (
    <div className="festapp-search festapp-search-skeleton">
      <Skeleton className="festapp-search-input-skeleton" />
    </div>
  );
}

export function TabsSkeleton() {
  return (
    <div className="festapp-tabs festapp-tabs-skeleton">
      <Skeleton width={80} height={24} />
      <Skeleton width={80} height={24} />
    </div>
  );
}
